import { Pipe, PipeTransform } from '@angular/core';
import { OsobaVysledekDto } from '@generated/be';
import { formatOsoba } from '../misc/osoba.utils';

@Pipe({
  name: 'displayOsoba',
  standalone: true,
})
export class DisplayOsobaPipe implements PipeTransform {
  transform(value: OsobaVysledekDto | null | undefined): string {
    return formatOsoba(value);
  }
}
